var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownMouse = function SvgDownMouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.35 56.498"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes svg_mouse_wheel{0%{transform:translate(-4.58px,0)}to{transform:translate(-4.58px,10px)}}@keyframes svg_mouse_down_arrow{0%{transform:translate(-2px,-20px)}to{transform:translate(-2px,-17px)}}")), /*#__PURE__*/React.createElement("g", {
    id: "down_mouse_svg__down_mouse",
    transform: "translate(-30 -20.5)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down_mouse_svg__Path_14180",
    fill: "#8e8e8e",
    d: "M44.675 20.5A14.72 14.72 0 0 0 30 35.175v13.941a14.675 14.675 0 0 0 29.35 0V35.175A14.72 14.72 0 0 0 44.675 20.5m10.492 28.616a10.493 10.493 0 1 1-20.985 0V35.175a10.493 10.493 0 0 1 20.985 0Z",
    "data-name": "Path 14180"
  })), /*#__PURE__*/React.createElement("path", {
    id: "down_mouse_svg__Path_14181",
    d: "M49.254 32.4a2.05 2.05 0 0 0-2.054 2.054V40.1a2.05 2.05 0 0 0 2.054 2.054 2.1 2.1 0 0 0 2.055-2.054v-5.65a2.05 2.05 0 0 0-2.055-2.05",
    "data-name": "Path 14181",
    style: {
      fill: "#f05a5c",
      animation: "svg_mouse_wheel 1s infinite alternate",
      transformOrigin: "center"
    },
    transform: "translate(-4.58 -3.168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "down_mouse_svg__Path_14182",
    fill: "#8e8e8e",
    d: "m51.006 85.58-3.6 3.6-3.6-3.6a2.075 2.075 0 0 0-2.935 2.935l5.063 5.063a1.99 1.99 0 0 0 1.467.587 2.18 2.18 0 0 0 1.467-.587l5.063-5.063a2.075 2.075 0 1 0-2.935-2.935Z",
    "data-name": "Path 14182",
    style: {
      animation: "svg_mouse_down_arrow 1500ms infinite alternate",
      transformOrigin: "center"
    },
    transform: "translate(-2.736 -20.167)"
  })));
};
export default SvgDownMouse;